import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import { Wrapper } from 'hb-builder/components/common/Wrapper/WrapperRender';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { BodyItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/bodyItemAttributes';

const componentType = 'body';

const Body: RenderComponent = () => <div />; // never used

const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<BodyItemAttributes>>) => {
  const { ids, isMobilePreview } = useRendererContext();
  const attributes = item?.attributes;

  return (
    // @ts-expect-error Wrapper is not typed
    <Wrapper
      attributes={attributes}
      componentType={componentType}
      isMobilePreview={isMobilePreview}
      style={{
        backgroundColor: attributes?.bodyBackgroundColor,
        display: 'block',
        height: 'auto',
        flex: 1,
        width: ids?.context?.includes('email') && attributes?.bodyWidth,
      }}
    >
      {children}
    </Wrapper>
  );
};

Body.componentName = 'Body';
Body.Render = Render;

export default Body;
